module.exports = __webpack_public_path__ + "img/plan1.08405232.png";